const COACH_APPROVAL_MARKER_REGEX = /\s*\[Approval:\s*(Required|Not Required)\]/gi;

export function sanitizeCoachMessageContent(content: string): string {
  return content
    .replace(COACH_APPROVAL_MARKER_REGEX, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
